import { QuoteService } from 'quote-domain-core';
import { PricingItemCorridorService } from '../pricing-item/pricing-item-corridor-service';
import { singleton } from 'tsyringe';

@singleton()
export class QuoteServiceBaseCorridorService {
    constructor(private readonly pricingItemCorridorService: PricingItemCorridorService) {
    }

    public applyBaseCorridor(quoteService: QuoteService): void {
        (quoteService.customGroups ?? []).forEach(customGroup => {
            (customGroup.pricingItems ?? []).forEach(pricingItem => {
                this.pricingItemCorridorService.searchAndApplyBaseCorridor(pricingItem, quoteService.contractInfoInputs, quoteService.code, quoteService.salesType);
            });
        });
    }

    public setArticleCorridorFromArticleLastCorridorState(quoteService: QuoteService): void {
        (quoteService.customGroups ?? []).forEach(customGroup => {
            (customGroup.pricingItems ?? []).forEach(pricingItem => {
                this.pricingItemCorridorService.setArticleCorridorFromArticleLastCorridorState(pricingItem);
            });
        });
    }
}
